import { Button, Typography } from 'antd';
import { useCallback, useMemo } from 'react';

import type { NTextFile } from '@app/components/Chat/components/TextFileComponent/TextFileComponent.types';
import { generateKey } from '@app/utils';

export const TextFileComponent: NTextFile.Main = ({
  getFileImage,
  file,
  action,
  downloadFile,
  isMessageComponent,
}) => {
  const files = useMemo(
    () =>
      action.Files
        ? action.Files
        : action.ChatMessages?.length && action.ChatMessages[0].File
        ? Array(action.ChatMessages[0].File)
        : [],
    [action.ChatMessages, action.Files]
  );

  const cutString = useCallback((str: string): string => {
    const prefix = str.substring(0, 20);
    const suffix = str.substring(str.length - 20);

    return `${prefix}...${suffix}`;
  }, []);

  return (
    <div
      key={generateKey('TextFileComponent', file.Id || '')}
      style={{ fontSize: '12px' }}
    >
      <div className="action-item" style={{ backgroundColor: 'none' }}>
        <div style={{ marginRight: '10px' }}>
          {file.FileName !== undefined && file.Thumbnail !== undefined
            ? getFileImage({
                fileName: file.FileName,
                filesWithData: files,
                Thumbnail: file.Thumbnail,
                isHistoryItem: true,
                fileExtension: file.Extension,
              })
            : null}
        </div>
        <Button
          type={'link'}
          style={{
            padding: '0',
            height: 'auto',
          }}
          onClick={() => {
            if (file.Id && file.Extension) {
              downloadFile(file.Id, file.Extension);
            }
          }}
        >
          {isMessageComponent
            ? file.FileName && file.FileName?.length > 40
              ? cutString(file.FileName)
              : file.FileName
            : file.FileName}
        </Button>
        {!isMessageComponent && (
          <Typography.Text type="secondary" style={{ marginLeft: '20px' }}>
            {file.Description}
          </Typography.Text>
        )}
      </div>
    </div>
  );
};
